import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzSubjectPermissionGroup = React.lazy(() =>
    import('../AuthzSubjectPermissionGroup')
);
const authzSubjectPermissionGroupRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_GROUP_PAGE,
        element: <AuthzSubjectPermissionGroup />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzSubjectPermissionGroupRoutesRegistry;
